// @core/api/endpoints/project/list_labels.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLabelsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List labels
 * Returns all labels defined for the project.
 */
export async function ListLabels(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLabelsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/labels`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListLabelsResponse>(requestPath, { ...requestOptions, params });
}
